(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[671],{

/***/ "evgB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "User", function() { return User; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var User = function User(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 500 500"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    d: "M249.9 240c-66.1 0-120-53.8-120-120 .1-66.2 53.9-120 120-120s120 53.8 120 120c.1 66.2-53.8 120-120 120zm0-207.5c-48.3 0-87.6 39.2-87.6 87.6s39.2 87.6 87.6 87.6 87.6-39.2 87.6-87.6-39.3-87.6-87.6-87.6zM412.2 500c-9 0-16.2-7.3-16.2-16.2 0-97.9-11-179-145.9-179s-146 81.1-146 179c0 8.9-7.3 16.2-16.2 16.2s-16.3-7.3-16.3-16.2c0-102.3 13.8-211.4 178.4-211.4s178.4 109.1 178.4 211.4c0 8.9-7.3 16.2-16.2 16.2z"
  }));
};

/***/ })

}]);